export default "__VITE_ASSET__DSEe0dT___"